export const es = {
  welcome: 'Bienvenido',
  logout: 'Cerrar sesión',
  settings: 'Ajustes',

  days: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  today: 'Hoy',
  yesterday: 'Ayer',

  THEME: {
    DARK: 'Oscuro',
    LIGHT: 'Claro',
  },

  PLACEHOLDER: {
    SEARCH_PLACEHOLDER: 'Buscar...',
    SELECT_OPTION: 'Seleccione una opción...',
    SELECT_STATUS: 'Seleccione estado...',
    CHOOSE_STATUS: 'Elige estado...',
    LOCATION: 'Ingrese una ciudad, dirección o lugar...',
    DESCRIPTION: 'Descripción del incidente',
    AI_DESCRIPTION:
      'Describa lo que ocurrió, dónde y cuándo — p. ej. Hubo un pequeño incendio en la sala eléctrica cerca de Balestier Road, Novena.',
    LOCATION_DESCRIPTION: 'Detalles adicionales sobre la ubicación',
    VALIDATING: 'Validando...',
    GENERATING: 'Generando...',
  },

  CHAT_PANEL: {
    SEARCH_PLACEHOLDER: 'Buscar...',
    NO_MESSAGES_YET: 'Aún no hay mensajes',
    IS_SPEAKING: 'está hablando...',
    ONLINE: 'en línea',
    OFFLINE: 'desconectado',
    TRANSCRIBING: 'Transcribiendo...',
    NO_CHAT_FOUND: 'No se encontraron chats',
    NO_CHAT_SELECTED_TITLE: 'Ningún chat seleccionado',
    NO_CHAT_SELECTED_DESCRIPTION: 'Selecciona un usuario o grupo del menú lateral para comenzar a enviar mensajes',
    INPUT_PLACEHOLDER_DEFAULT: 'Escribe un mensaje...',
    INPUT_PLACEHOLDER_WITH_ATTACHMENT: 'Agrega un título...',
    IS_TALKING: 'está hablando...',
    PTT_ACTIVE: 'PTT activo – hablando...',
    PTT_LOCKED: 'PTT bloqueado – haz clic para liberar',
    PTT_SLIDE_HINT: 'Desliza hacia arriba para bloquear',
    PTT_RELEASE_AND_SEND: 'Soltar y enviar',
    ATTACHED_FILES_TITLE: 'Archivos adjuntos',
    FAILED_TO_TRANSCRIBE_AUDIO: 'Error al transcribir audio',
    NO_CHAT_MESSAGE: 'No hay mensaje de chat',
    FALLBACK_MESSAGE: 'Para iniciar un chat, escribe tu mensaje o usa la función PTT/PTV.',
    INCOMING_VIDEO_CALL: 'Llamada PTV entrante...',
    SOMETHING_WENT_WRONG: 'Algo salió mal',
    ERROR: 'Error:',
    NO_MESSAGES_FOUND_FOR: 'No se encontraron mensajes para',
    SYSTEM_MESSAGE: 'Mensaje del sistema',
    GROUP: 'grupo',
    AUDIO: 'audio',
    VIDEO: 'video',
    FILE: 'archivo',
    ME: 'yo',
    IMAGE: 'imagen',
    TEXT: 'texto',
    CHAT: 'chat',
    NONE: 'ninguno',
    PROFILE: 'perfil',
    SEARCH: 'buscar',
    COMPLETED: 'completado',
    RESOLVED: 'resuelto',
    USER_EMAIL_DOMAIN: '@widebridgecloud.com',
    UNKNOWN: 'Desconocido',
    THEM: 'ellos',
    HAS_ACCEPTED_THE_INCIDENT: 'ha aceptado el incidente',
    INCIDENT_HAS_BEEN_UPDATED: 'El incidente ha sido actualizado',
    INCIDENT_HAS_BEEN_RESOLVED: 'El incidente ha sido resuelto',
    YOU_HAVE_JOINED_THE_GROUP: 'Te has unido al grupo',
  },

  PROFILE_PANEL: {
    MEMBERS_LABEL: 'miembros',
    GROUP_MEMBERS_TITLE: 'Miembros del grupo',
    USERNAME_LABEL: 'Nombre de usuario',
    EMAIL_LABEL: 'Correo electrónico',
    MEMBER_FALLBACK_NAME: 'Miembro',
    MEMBER_FALLBACK_ID: 'Miembro',
  },

  PTT: {
    AUDIO: {
      FILENAME_PREFIX: 'ptt-audio-',
      FILE_TYPE: 'audio/webm',
      FILE_EXTENSION: '.webm',
    },
    MESSAGES: {
      START_RECORDING: 'Grabación PTT iniciada para {{userName}}',
      STOP_RECORDING: 'Audio PTT enviado a {{userName}}',
      NO_AUDIO_DATA: 'No se recibieron datos de audio del SDK',
      TRANSCRIPTION_SUCCESS: 'Transcripción de audio completada',
      TRANSCRIPTION_FAILED: 'Transcripción falló, enviando audio sin texto',
    },
    TRANSCRIPTION: {
      MODEL: 'whisper-1',
      LANGUAGE: 'es',
      RESPONSE_FORMAT: 'text',
    },
  },

  CHAT_WINDOW: {
    SEARCH_IN: 'Buscar en',
    YOUR_PROFILE: 'Tu perfil',
    VIEW_PROFILE: 'Ver perfil',
    PIN_CHAT: 'Fijar chat',
    UNPIN_CHAT: 'Desfijar chat',
    MUTE_CHAT: 'Silenciar chat',
    UNMUTE_CHAT: 'Activar sonido del chat',
  },

  DASHBOARD: {
    INCIDENTS: 'incidentes',
    INCIDENTS_NO_DATA: 'Para crear un incidente, haga clic en el botón "+ Crear incidente"',
    RESPONDERS: 'respondedores',
    RESPONDERS_NO_DATA: 'No se encontraron respondedores.',
    CHAT: 'chat',
    ALERTS: 'alertas',
    ALERTS_NO_DATA: 'No hay alertas generadas por el sistema.',
    UPDATES: 'actualizaciones',
    UPDATES_NO_DATA: 'No hay actualizaciones sobre el incidente o los respondedores.',
    NEW_MESSAGE_FROM: 'Nuevo mensaje de',
    INCIDENT_UPDATED_BY: 'Incidente actualizado por',
    NEW_INCIDENT_CREATED_BY: 'Nuevo incidente creado por',
    PROFILE: 'perfil',
    SUMMARY: 'resumen',
    GENERATING_SUMMARY: 'generando resumen...',
  },

  INCIDENTS_PANEL: {
    INCIDENT_NAME: 'Nombre del incidente',
    INCIDENT_TYPE: 'Tipo de incidente',
    ASSIGNEES: 'asignado(s)',
    SEVERITY: 'severidad',
    STATUS: 'estado',
    STATUS_HISTORY: 'Historial de estado',
    SHOW: 'Mostrar',
    SHOW_LESS: 'Mostrar menos',
    MORE: 'más',
    PTT: 'PTT',
    LOCATION: 'ubicación',
    SEVERITY_CRITICAL: 'crítico',
    SEVERITY_HIGH: 'alto',
    SEVERITY_MEDIUM: 'medio',
    SEVERITY_LOW: 'bajo',
    SEVERITY_MINIMAL: 'mínimo',
    REPORTED_DATE_TIME: 'Fecha y hora reportada',
    REPORTED_NAME: 'Nombre del informante',
    DESCRIPTION: 'descripción',
    RESPONDERS: 'respondedor(es)',
    ATTACHMENTS: 'archivos adjuntos',
    LOCATION_DESCRIPTION: 'descripción de la ubicación',
    NO_RESPONDERS_ASSIGNED: 'No hay respondedores asignados al incidente.',
    CREATE_INCIDENT: 'Crear incidente',
    EDIT_INCIDENT: 'Editar incidente',
    SELECT_RESPONDERS: 'Seleccionar respondedores',
    COMPLETE: 'Completar',
    CANCEL: 'Cancelar',
    SAVE: 'Guardar cambios',
    NO: 'No',
    DATA_FOUND: 'Datos encontrados',
    NO_OPTIONS: 'No hay opciones disponibles',
    AI_ASSISTANCE: 'Asistencia de IA',
  },

  TAB_KEYS: {
    ALL: 'todos',
    UNREAD: 'no leído',
    ACTIVE: 'activo',
    CLOSED: 'cerrado',
    AVAILABLE: 'disponible',
    OFFLINE: 'sin conexión',
    TAB_VALUE_UNACKNOWLEDGED: 'no reconocido',
    TAB_VALUE_CREATED: 'creado',
    TAB_VALUE_PROGRESS: 'en progreso',
    TAB_VALUE_RESOLVED: 'resuelto',
  },

  UPDATES_PANEL: {
    UPDATES: 'Actualizaciones',
    MARK_AS_READ: 'Marcar todo como leído',
    ALL: 'Todos',
    UNREAD: 'No leídos',
    ALL_KEY: 'all',
    UNREAD_KEY: 'unread',
    NO_NOTIFICATIONS: 'No hay notificaciones',
    NO_UNREAD_NOTIFICATIONS: 'No hay notificaciones sin leer',
    UPDATE_STATUS: 'Actualizar estado:',

    // Notification titles
    NEW_INCIDENT_TITLE: 'Nuevo Incidente',
    UPDATE_TITLE: 'Actualización',

    CREATED_AT: 'creado en',

    // Status labels
    STATUS_CLOSED: 'Cerrado',
    STATUS_IN_PROGRESS: 'En Progreso',

    // Change descriptions
    STATUS_CHANGE: 'Estado',
    SEVERITY_CHANGE: 'Gravedad',
    TYPE_CHANGE: 'Tipo',
    DESCRIPTION_UPDATED: 'Descripción actualizada',
    RESPONDERS_ADDED: 'respondedor(es) agregado(s)',
    RESPONDERS_REMOVED: 'respondedor(es) eliminado(s)',
    RESPONDERS_UPDATED: 'Respondedores actualizados',
    LOCATION_CHANGED: 'Ubicación cambiada',
    UPDATED_DEFAULT: 'Actualizado',

    //Time
    UNKNOWN: 'Desconocido',
    JUST_NOW: 'justo ahora',
    MINUTES_AGO: 'hace {{count}} min',
    MINUTES_AGO_plural: 'hace {{count}} mins',
    HOURS_AGO: 'hace {{count}} hora',
    HOURS_AGO_plural: 'hace {{count}} horas',
    DAYS_AGO: 'hace {{count}} día',
    DAYS_AGO_plural: 'hace {{count}} días',

    // Default values
    DEFAULT_TYPE: 'Incidente',
    UNKNOWN_LOCATION: 'Ubicación desconocida',
  },
  MAP_VIEW: {
    INCIDENT_TOOLTIP: {
      INCIDENTTYPE: 'Tipo de Incidente',
      REPORTEDDATE: 'Fecha Reportada',
      SEVERITY: 'Gravedad',
      STATUS: 'Estado',
      RESPONDERS: 'Respondedores',
      NO_RESPONDERS: 'No hay respondedores disponibles',
    },
    INCIDENT_CLUSTER_TOOLTIP: {
      INCIDENTS: 'Incidentes',
      MORE: 'más...',
    },
    MAP_FILTER: {
      VIEW_MODE: 'Modo de Vista',
      DEFAULT: 'Predeterminado',
      SATELLITE: 'Satélite',
      FILTER_BY: 'Filtrar Por',
      ALL: 'todos',
      ACTIVE: 'Activo',
      COMPLETED: 'Completado',
      RESPONDERS: 'Respondedores',
      AVAILABLE: 'disponible',
    },
  },

  FALLBACK_SCREEN: {
    NO: 'No',
    DATA_FOUND: 'Datos Encontrados',
    CREATE_INCIDENT: 'Crear Incidente',
    NO_AVAILABLE_RESPONDER_FOUND: 'No se encontró un respondedor disponible',
  },

  PERMISSION_DIALOG: {
    MICROPHONE: {
      TITLE: 'Se requiere acceso al micrófono',
      DESCRIPTION: 'Esta aplicación necesita acceso a su micrófono para funcionar correctamente.',
      INSTRUCTION: 'Por favor, conceda permiso al micrófono para continuar usando la aplicación.',
      BUTTON_LABEL: 'Conceder permiso al micrófono',
    },
    CAMERA: {
      TITLE: 'Se requiere acceso a la cámara',
      DESCRIPTION: 'Esta aplicación necesita acceso a su cámara para funcionar correctamente.',
      INSTRUCTION: 'Por favor, conceda permiso a la cámara para continuar usando la aplicación.',
      BUTTON_LABEL: 'Conceder permiso a la cámara',
    },
    NOTIFICATIONS: {
      TITLE: 'Se requiere permiso de notificaciones',
      DESCRIPTION: 'Esta aplicación necesita permiso para enviarle notificaciones.',
      INSTRUCTION: 'Por favor, conceda permiso de notificaciones para continuar usando la aplicación.',
      BUTTON_LABEL: 'Conceder permiso de notificaciones',
    },
    GEOLOCATION: {
      TITLE: 'Se requiere acceso a la ubicación',
      DESCRIPTION: 'Esta aplicación necesita acceso a su ubicación para funcionar correctamente.',
      INSTRUCTION: 'Por favor, conceda permiso de ubicación para continuar usando la aplicación.',
      BUTTON_LABEL: 'Conceder permiso de ubicación',
    },
    HEADINGS: {
      WHAT_TO_DO: 'Lo que necesita hacer:',
      ADDITIONAL_REQUIRED: 'Permisos adicionales requeridos',
      GENERIC_PERMISSION_TITLE: 'Permiso requerido',
      GENERIC_DESCRIPTION: 'Esta aplicación necesita permisos adicionales para funcionar correctamente.',
      GENERIC_INSTRUCTION: 'Por favor, conceda los permisos necesarios para continuar.',
    },
    DEFAULT_BUTTON_LABEL: 'Conceder permiso',
  },
  SETTINGS: {
    TITLE: 'Configuración',
    SUBTITLE: 'Administra tus preferencias de idioma y traducción',
    LANGUAGE_DISPLAY: 'Idioma de visualización',
    AUTO_TRANSLATE_TITLE: 'Activar traducción automática',
    AUTO_TRANSLATE_DESCRIPTION: 'Traduce automáticamente los mensajes entrantes a tu idioma seleccionado.',
    SAVE_BUTTON: 'Guardar',
    SELECT_PLACEHOLDER: 'Selecciona una opción...',
  },
  SOS_MODAL: {
    TITLE_ALERT_TRIGGERED: 'Alerta SOS activada',
    LOCATION_LABEL: 'Ubicación',
    INCIDENT_LABEL: 'Incidente',
    LAST_STATUS_LABEL: 'Último estado',
    ASSIST_BUTTON: 'Asistir',
  },
  HEADER: {
    USERNAME: 'Nombre de usuario',
    MODE: 'Modo',
    SETTINGS: 'Configuración',
    LOG_OUT: 'Cerrar sesión',
    TITLE: 'AGIL Field Ops',
  },

  ERRORS: {
    INVALID_CHAT_DATA: 'Datos de chat no válidos',
    SUMMARY_GENERATION_FAILED: 'Error al generar el resumen:',
    FAILED_TO_GENERATE_SUMMARY: 'No se pudo generar el resumen.',
    PLEASE_TRY_AGAIN: 'Por favor, inténtalo de nuevo.',
    UNKNOWN: 'Desconocido',
    IN_PROGRESS_STATUS_ERROR: 'Debe asignarse al menos un respondedor cuando el estado es "En progreso"',
    RESOLVED_STATUS_ERROR: 'Debe asignarse al menos un respondedor antes de cerrar el incidente',
    SELECT_ONE_RESPONDER_ERROR: 'Por favor, selecciona al menos un respondedor',
    WAIT_BEFORE_SUBMIT_AGAIN: 'Por favor, espera antes de enviar de nuevo',
    INCIDENT_CREATION_SERVICE_UNAVAILABLE:
      'El servicio de creación de incidentes no está disponible. Inténtalo de nuevo más tarde.',
    NO_CHANGES_TO_UPDATE: 'No hay cambios para actualizar',
    FAILED_TO_UPDATE_INCIDENT: 'No se pudo actualizar el incidente. Verifica tu conexión e inténtalo de nuevo.',
    FAILED_TO_CREATE_INCIDENT: 'No se pudo crear el incidente. Verifica tu conexión e inténtalo de nuevo.',
  },

  INCIDENT_TYPES: [
    { value: 'Medical', label: 'Médico' },
    { value: 'Car accident', label: 'Accidente de coche' },
    { value: 'Fire', label: 'Incendio' },
    { value: 'Patrol', label: 'Patrulla' },
  ],

  SEVERITY_VALUES: [
    { value: 4, label: 'Crítico', dotColor: 'bg-icon-error' },
    { value: 3, label: 'Alto', dotColor: 'bg-chart-2' },
    { value: 2, label: 'Medio', dotColor: 'bg-chart-4' },
    { value: 1, label: 'Bajo', dotColor: 'bg-interactive' },
    { value: 0, label: 'Mínimo', dotColor: 'bg-icon-muted' },
  ],

  INCIDENT_CARD_STATUS_VALUES: [
    { value: 'created', label: 'Creado' },
    { value: 'progress', label: 'En progreso' },
    { value: 'resolved', label: 'Resuelto' },
  ],

  CREATE_INCIDENT_STATUS_VALUES: [
    { value: 'open', label: 'Creado' },
    { value: 'in_progress', label: 'En progreso', disabled: false },
  ],

  EDIT_INCIDENT_STATUS_VALUES: [
    { value: 'in_progress', label: 'En progreso' },
    { value: 'resolved', label: 'Cerrado' },
  ],

  INCIDENT_DETAILS_STATUS_VALUES: [
    { value: 'created', label: 'Creado', disabled: true },
    { value: 'progress', label: 'En progreso', disabled: true },
    { value: 'resolved', label: 'Cerrado', disabled: true },
  ],

  RESPONSE_STATUS: [
    { value: 'accepted', label: 'Aceptado' },
    { value: 'rejected', label: 'Rechazado' },
    { value: 'pending', label: 'Pendiente' },
  ],

  ASSIGNEE_STATUS: [
    { value: 'not_started', label: 'No iniciado' },
    { value: 'on_the_way', label: 'En camino' },
    { value: 'reach_site', label: 'En el sitio' },
    { value: 'enroute', label: 'En ruta' },
    { value: 'done', label: 'Hecho' },
  ],

  RESPONDER_STATUS: [
    { value: 'Unacknowledged', label: 'No reconocido' },
    { value: 'Rejected', label: 'Rechazado' },
    { value: 'Arrived at scene', label: 'Llegó al lugar' },
    { value: 'On the way', label: 'En camino' },
    { value: 'Aborted', label: 'Abortado' },
    { value: 'Done', label: 'Hecho' },
  ],

  WEEKDAYS: [
    { value: 'Sun', label: 'Dom' },
    { value: 'Mon', label: 'Lun' },
    { value: 'Tue', label: 'Mar' },
    { value: 'Wed', label: 'Mié' },
    { value: 'Thu', label: 'Jue' },
    { value: 'Fri', label: 'Vie' },
    { value: 'Sat', label: 'Sáb' },
  ],
};
